import { render, staticRenderFns } from "./XInputGender.vue?vue&type=template&id=41470ff6"
import script from "./XInputGender.vue?vue&type=script&lang=js"
export * from "./XInputGender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports